/* eslint-disable no-invalid-this,sonarjs/function-return-type */
import yup from '@/libs/yup';

const MAX_IDN_LENGTH = 120;

export default yup.object({
    idn: yup.string().idn(undefined, MAX_IDN_LENGTH).required(),
    group: yup.string(),
    value_type: yup
        .string()
        .oneOf(['string', 'enum', 'bool', 'number', 'json'])
        .required(),
    possible_values: yup
        .array()
        .of(yup.string())
        .test('validate-possible-values', '', function (value) {
            if (this.parent.value_type === 'enum' && value?.length === 0) {
                return this.createError({
                    message: 'At least one possible value is required'
                });
            }
            return true;
        }),
    value: yup
        .mixed()
        .test('validate-value', 'Invalid value', function (value) {
            if (this.parent.value_type === 'json') {
                if (typeof value !== 'string') return false;
                try {
                    JSON.parse(value);
                    return true;
                } catch {
                    return this.createError({
                        message: 'Value must be a valid JSON string'
                    });
                }
            }

            if (this.parent.value_type === 'enum' && !value) {
                return this.createError({
                    message: 'Value is required'
                });
            }

            return true;
        })
});
